// src/App.js

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Shop_1 from './pages/Shop_1';
import Shop_2 from './pages/Shop_2';
import CategoryDetail from './pages/CategoryDetail';
import Dashboard from './pages/Dashboard';
import Shop1Category from './pages/Shop1Categories';
import Shop2Category from './pages/Shop2Categories';
import Login from './pages/Login';


const PrivateRoute = ({ element: Component }) => {
  const isAuthenticated = !!localStorage.getItem('token');
  return isAuthenticated ? <Component /> : <Navigate to="/login-mdash" />;
};

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login-mdash" element={<Login />} />
      <Route path="/dashboard" element={<PrivateRoute element={Dashboard} />} />
      <Route path="/mj-shopcategory" element={<PrivateRoute element={Shop1Category} />} />
      <Route path="/rmj-shopcategory" element={<PrivateRoute element={Shop2Category} />} />
      <Route path="/categories/:name" element={<PrivateRoute element={CategoryDetail} />} />
      <Route path="/mj-shop" element={<PrivateRoute element={Shop_1} />} />
      <Route path="/rmj-shop" element={<PrivateRoute element={Shop_2} />} />
    </Routes>
  );
}

